import linkResolver from 'prismic-configuration.js';
import { RichText } from 'prismic-reactjs';
import { useState } from 'react';
import {
  Carousel,
} from 'react-bootstrap';
import key from 'weak-key';

function CarouselSlice(body) {
  const { slice } = body;
  const carouselContent = slice.items.map((slide) => {
    const image = slide.carousel_item_image;
    return (
      <Carousel.Item key={key(slide)}>
        {RichText.asText(slice.primary.carousel_title) !== '' && (
        <div className="carouselContainer container">
          <div className="row d-flex justify-content-center">
            <div className="col-1 blueline" />
            <div className="carouselTitle col-8">
              {RichText.render(slice.primary.carousel_title, linkResolver)}
            </div>
          </div>
        </div>
        )}
        <Carousel.Caption className="custom-caption-style">
          <picture className="mt-5">
            <source srcSet={image.url} />
            <img
              className="my-3"
              src={image.url}
              alt={image.alt == null ? '' : image.alt}
            />
          </picture>
          <div className="secondary-light-blue carouselSubtitle">
            {RichText.render(slide.carousel_item_title, linkResolver)}
          </div>
          <div className=" carouselText col-md-8 offset-md-2">
            {RichText.render(slide.carousel_item_description, linkResolver)}
          </div>
        </Carousel.Caption>
      </Carousel.Item>
    );
  });
  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };
  return (
    <div className="carousel text-center">
      <Carousel activeIndex={index} onSelect={handleSelect}>
        {carouselContent}
      </Carousel>
    </div>
  );
}

export default CarouselSlice;
